export default __webpack_public_path__ + "static/media/mobileDark.0ed8dec0.png";